let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kuPgl")).then(() => parcelRequire('5byen'));